import React from 'react';
import styled from 'astroturf/react';

type Props = {
  // Whether to show on mobile sizes
  showMobile?: boolean;
};

const Avatar = styled.div`
  background: #eaeaea;
  border-radius: 50%;
  height: 62px;
  grid-column: 1 / 2;
  grid-row: 1 / 4;
  width: 62px;
`;

const AvatarGroup = styled.div`
  display: grid;
  column-gap: 6px;
  grid-template-columns: auto 1fr;
  grid-template-rows: repeat(3, auto);
  margin-bottom: 72px;
`;

const Container = styled.div`
  background: #fff;
  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.25);
  padding: 18px 0 18px 18px;
  position: relative;
  width: 460px;

  @media (max-width: 1200px) {
    max-width: 395px;
  }

  @media (max-width: 992px) {
    display: none;
  }

  &.showMobile {
    @media (max-width: 992px) {
      display: block;
    }
  }

  &::after {
    background: linear-gradient(
      to right,
      transparent 0%,
      rgba(128, 128, 128, 0.12) 40%,
      rgba(128, 128, 128, 0.12) 60%,
      transparent 100%
    );
    background-repeat: no-repeat;
    background-size: 50%;
    content: '';
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 2;
  }
`;

const Hr = styled.hr`
  border-bottom: 1px solid #ddd;
  margin-top: 0;
  margin-bottom: 18px;
`;

const SectionContainer = styled.div`
  margin-bottom: 63px;
`;

const TextBlock = styled.div`
  background: #eaeaea;
  height: 18px;
  margin-bottom: 4px;
  width: 251px;

  &.short {
    width: 108px;
  }

  &.long {
    width: 356px;
  }
`;

const Section = ({ title }: { title?: boolean }) => (
  <SectionContainer>
    {/* @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call. */}
    {title && <TextBlock short />}
    <Hr />
    {/* @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call. */}
    <TextBlock long />
    <TextBlock />
  </SectionContainer>
);

const Loading = ({ showMobile }: Props) => (
  // This class applies the animation to the after element
  // Adding this to Container directly doesn't work
  // due to an issue with our postcss config I believe.
  // Astroturf adds `:local()` around the animation name,
  // but it doesn't get processed correctly and ends up in the outputted CSS,
  // which isn't valid.
  // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
  <Container className="swp-sidebar-loading-container" showMobile={showMobile}>
    {/* @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call. */}
    <TextBlock short />
    <Hr />

    <AvatarGroup>
      <Avatar />
      {/* @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call. */}
      <TextBlock short />
      <TextBlock />
    </AvatarGroup>

    <Section title />
    <Section title />
    <Section title />

    <Section />
    <Section />
    <Section />
  </Container>
);

export default Loading;
